const ICON_MAP = { search: '🔍', globe: '🌐', image: '🖼️', 'file-text': '📄', file: '📁', calculator: '🧮', code: '💻', 'bar-chart-2': '📊', braces: '🔗', hash: '#️⃣', clock: '⏰', layers: '🗂️', save: '💾', zap: '⚡', 'book-open': '📖', 'shopping-bag': '🛍️', package: '📦', shield: '🛡️', 'bar-chart': '📊' };

function createToolElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

function createState(message, retryAction = '') {
  const state = createToolElement('div', 'aichat-artifact-empty aichat-workbench-state', message);
  if (retryAction) {
    const retry = createToolElement('button', 'aichat-workbench-state-action', '点击重试');
    retry.type = 'button';
    retry.dataset.action = retryAction;
    state.append(document.createTextNode('，'), retry);
  }
  return state;
}

export function renderToolCapabilities(root, { capabilities = [], loadError = false } = {}) {
  if (!root) return;
  if (loadError) return void root.replaceChildren(createState('工具加载失败', 'retry-load-tools'));
  if (!capabilities.length) return void root.replaceChildren(createState('工具加载中…'));
  const nodes = [];
  capabilities.forEach((category) => {
    nodes.push(createToolElement('div', 'aichat-tool-category-label', category.label || category.category || '工具'));
    (category.tools || []).forEach((tool) => {
      const card = createToolElement('article', `aichat-tool-card${tool.available === false ? ' aichat-tool-card--disabled' : ''}`);
      const body = createToolElement('div', 'aichat-tool-card__body');
      body.append(createToolElement('div', 'aichat-tool-card__name', tool.userDescription || tool.name || tool.code || '未命名工具'));
      if (tool.available === false) body.append(createToolElement('div', 'aichat-tool-card__state', '未启用'));
      card.append(createToolElement('div', 'aichat-tool-card__icon', ICON_MAP[tool.icon] || '🔧'), body);
      nodes.push(card);
    });
  });
  root.replaceChildren(...nodes);
}
